import { BorderStyle, normalizeColor } from '@email-editor/ui'
import { ColorPicker } from '@systemeio/ui'
import NumberField from '../../components/NumberField'
import Select from '../../components/Select'
import { borderStyles } from './index'

export default function BorderRow(props: {
  width: number
  style: BorderStyle
  color: string
  updateWidth: (value: number) => void
  updateStyle: (value: BorderStyle) => void
  updateColor: (value: string) => void
}) {
  return (
    <div className="flex items-center gap-3">
      <NumberField value={props.width} update={props.updateWidth} min={0} />
      <Select choices={borderStyles} update={props.updateStyle} value={props.style} />
      <ColorPicker color={normalizeColor(props.color)} onChange={props.updateColor}>
        {() => (
          <div
            style={{ backgroundColor: props.color }}
            className="border-text-secondary/30 h-[30px] w-[30px] rounded-full border"
          />
        )}
      </ColorPicker>
    </div>
  )
}
